import { Col, Row, message } from 'antd';
import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import CustomTextArea from '../../../../../v2-components/Antd/TextArea';
import { approveButton } from './constants/approve-button.constant';
import { cancelButton } from './constants/cancel-button.constant';
import { confirmButton } from './constants/confirm-button.constant';
import { newQuotationButton } from './constants/new-quotation-button.constant';
import { statusNames } from './constants/status-names.constant';
import './style.scss';
import { paidQuotationButton } from './constants/paid-quotation-button.constant';
import { linkOrderButton } from './constants/link-order-button.constant';
import { useHistory } from 'react-router-dom';
import PurchaseModal from './components/PurchaseModal';


export default function StatusCard(props) {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openCancel, setOpenCancel] = useState(false);
	const [rejectReason, setRejectReason] = useState(null)
	const [observations, setObservations] = useState(null)
	const [openRequote, setOpenRequote] = useState(false);
	const [openPurchaseModal, setOpenPurchaseModal] = useState(false);
	const history = useHistory();


	const userInfo = JSON.parse(localStorage.getItem('userInfo'));


	const selectOptions = [
		{ label: "Profesional no habilitado para preescribir tratamiento", value: "Profesional no habilitado para preescribir tratamiento" },
		{ label: "Receta desenfocada", value: "Receta desenfocada"},
		{ label: "Receta incompleta", value: "Receta incompleta" },
		{ label: "Receta vencida", value: "Receta vencida" },
		{ label: "Falta de componentes", value: "Falta de componentes" },
		{ label: "Error en la cotización", value: "Error en la cotización" },
		{ label : "Otro", value: "Otro"}
	]




	const handleCancel = () => {
		setOpenCancel(true)
	};

	const handleReject = async () => {
		await props.handleCancelQuotation(rejectReason);
		setOpenCancel(false);
	};

	const handleApprove = async () => {
		const phone = props?.dataClient?.phone ? String(props.dataClient.phone).replace(/\D/g, '') : '';
		if (phone.length < 10) {
			setOpenConfirm(false);
			message.warning('El teléfono del cliente debe tener al menos 10 números.');
			return;
		}
		await props.handleApproveQuotation();
		setOpenConfirm(false);
	};
	const handleNext = () => {
		setOpenConfirm(true);
	};

	const handleConfirmRequote = async () => {
    await props.handleRequote();
    setOpenRequote(false);
  }


	return (
		<div className="status-card-container"> 
			<Row>
				<Col span={24}>
					<h3>Estado de la solicitud</h3>
					<span>{statusNames[Enviroment.LANGUAGE][props?.statusNumber]}</span>
				</Col>
				{props?.statusNumber === 100 && (
					<>
						<p>Antes de cerrar la solicitud de producto verifica los datos.</p>
						<p>Tambien puedes rechazarla desde aquí</p>
					</>
				)}
				{(props?.statusNumber === 100 || props?.statusNumber === 400) && (
					<p>El usuario tendrá hasta el vto. de la receta para hacer la compra. Una vez pasado ese plazo se rechazará la cotización. En caso de que el pago se haya hecho por otra vía puedes avanzar la compra desde aquí.</p>
				)}
					{props?.statusNumber === 500 && (
					<>
			 <Col span={24}>
      <p>Se rechazó la cotización por: {props?.status?.reason}</p>
    </Col>

    <Col span={24}>
      <p>Si deseas crear una nueva cotización con los nuevos productos puedes hacerlo.</p>
    </Col>
					</>
				)}
						{props?.statusNumber === 600 && (
					<>
						<p>El usuario ya abonó la cotización y se ha creado una orden con los productos cotizados.</p>
						<p>Si deseas crear una nueva cotización con los mismos productos puedes hacerlo.</p>
					</>
				)}
			</Row>
			<Row justify={'center'}>
				<Col>

					<CustomButton style={{ opacity: props?.statusNumber === 100 || props?.statusNumber === 400 ? 1 : 0, backgroundColor: '#D2000C', color: '#FFFFFF', }} onClick={handleCancel}   disabled={props?.statusNumber !== 100 && props?.statusNumber !== 400}>
						{cancelButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
				<Col>
					<CustomButton style={{ opacity: props?.statusNumber === 100 ? 1 : 0, backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '30px' }} onClick={handleNext} disabled={props?.statusNumber !== 100}>
						{approveButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
				<Col>
					<CustomButton style={{ opacity: props?.statusNumber === 500 || props?.statusNumber === 600  ? 1 : 0, backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '30px' }} onClick={() => setOpenRequote(true)} disabled={props?.statusNumber !== 500 && props?.statusNumber !== 600}>
						{newQuotationButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
					<Col>
					<CustomButton style={{ opacity: props?.statusNumber === 400  ? 1 : 0, backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '30px' }} onClick={() => setOpenPurchaseModal(true)} disabled={props?.statusNumber !== 400}>
						{paidQuotationButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
					<Col>
					<CustomButton style={{ opacity: props?.statusNumber === 600  ? 1 : 0, backgroundColor: '#686e6a', color: '#FFFFFF', marginLeft: '30px' }} onClick={() => history.push(`/v2/tracking/detail/${userInfo?.pharmacy}/${props?.trx_id}`)} disabled={props?.statusNumber !== 600}>
						{linkOrderButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
				
			</Row>

			<CustomModal onCancel={() => setOpenConfirm(false)} footer={null} open={openConfirm}>
				<h2>Avanzar</h2>
				<CustomDivider />
				<h5>Al darle a continuar estas confirmando que el estado está completo</h5>
				<p>Si estas de acuerdo dale a continuar</p>
				<CustomDivider />
				<div className="button-container">
					<CustomButton onClick={() => setOpenConfirm(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleApprove}>{confirmButton[Enviroment.LANGUAGE][props?.statusNumber]}</CustomButton>
				</div>
			</CustomModal>

			<CustomModal onCancel={() => setOpenCancel(false)} footer={null} open={openCancel}>
				<h2>Rechazo de cotización</h2>
				<CustomDivider />
				<h4>Seleccione el motivo del rechazo</h4>
				<CustomSelect style={{ width: '100%' }} options={selectOptions} size={'large'} placeholder={'Seleccionar motivo'} onChange={(e)=>setRejectReason(e)} />
				<CustomTextArea style={{marginTop: 20}} placeholder={'Observaciones'} onChange={(e)=>setObservations(e)} />
				<CustomDivider />
				<div>
					<CustomButton onClick={() => setOpenCancel(false)}>Cancelar</CustomButton>
					<CustomButton disabled={!rejectReason} onClick={handleReject}>Rechazar</CustomButton>
				</div>
			</CustomModal>
			<CustomModal onCancel={() => setOpenRequote(false)} footer={null} open={openRequote}>
        <h2>Nueva cotización</h2>
        <CustomDivider />
        <h4>Al darle a continuar estas confirmando que deseas generar una nueva cotización con los mismos datos.</h4>
        <p>Una vez creada la cotización el usuario recibirá un mail con la creación de una nueva cotización</p>
        <CustomDivider />
        <div className="button-container">
          <CustomButton onClick={() => setOpenRequote(false)}>Cancelar</CustomButton>
          <CustomButton onClick={handleConfirmRequote}>Continuar</CustomButton>
        </div>
      </CustomModal>

			<PurchaseModal
				open={openPurchaseModal}
				onClose={() => setOpenPurchaseModal(false)}
				quotationData={props.quotationData}
				quotationId={props.quotationId}
				onSuccess={props.onPurchaseSuccess}
			/>
		</div>
	);
}
